import { forwardRef, Box, BoxProps } from '../../chakra'

/**
 * IconWithNotification
 *
 * A utility component designed specifically for showing the DotIndicator with Icons since that is
 * the dominant use case for the `DotIndicator`:
 *
 * See: https://storybook.beta.vndly.com/?path=/docs/components-notification-indicators--docs
 */
export const IconWithNotification = forwardRef(({ children, ...props }: BoxProps, ref) => {
  return (
    <Box display="flex" pos="relative" w="fit-content" ref={ref} {...props}>
      {children}
    </Box>
  )
})
